module.exports = __webpack_public_path__ + "img/lewis-hamilton-feeds-kangaroos.7bdfce25.jpg";